import { Navigate, useNavigate, useParams } from 'react-router-dom'

import {
  FBPageInnerTabsContainer,
  FBPageTableContainer,
} from 'components/FbUI/Page/styles'
import { Tabs } from 'components/FbUI/Tabs'
import { SavedFiltersTable } from 'features/settings/components/SavedFiltersTable'
import { TagTable } from 'features/settings/components/TagTable'
import { ColumnPresetsTable } from 'features/settings/components/ColumnPresetsTable'

const DEFAULT_TAB = 'filters'

const tabs = [
  { key: 'filters', title: 'Filters' },
  { key: 'product-tags', title: 'Tags' },
  { key: 'contact-tags', title: 'Contact Labels' },
  { key: 'document-tags', title: 'Document Tags' },
  { key: 'deal-tags', title: 'Deal Tags' },
  { key: 'columns', title: 'Column Presets' },
]

const validTabs = new Set(tabs.map((t) => t.key))

export function DataSettingsPage() {
  const params = useParams()
  const navigate = useNavigate()
  const tab = params.tab ?? DEFAULT_TAB

  if (params.tab && !validTabs.has(params.tab)) {
    return <Navigate to={`/settings/data/${DEFAULT_TAB}`} replace />
  }

  return (
    <div className="w-full h-full flex flex-col flex-1 min-h-0">
      <FBPageInnerTabsContainer>
        <Tabs
          tabs={tabs}
          selectedTab={tab}
          setSelectedTab={(value) => navigate(`/settings/data/${value}`)}
          tabStyle={{ width: '125px' }}
        />
      </FBPageInnerTabsContainer>
      <FBPageTableContainer hide={tab !== 'filters'}>
        <SavedFiltersTable />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'product-tags'}>
        <TagTable tagParent="products" />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'contact-tags'}>
        <TagTable tagParent="contacts" />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'document-tags'}>
        <TagTable tagParent="documents" />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'deal-tags'}>
        <TagTable tagParent="deals" />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'columns'}>
        <ColumnPresetsTable />
      </FBPageTableContainer>
    </div>
  )
}
